"use client";

import { WhenAllReady } from "@nimble/react-requests/components/shared/when-all-ready";

import { withAuthGate } from "@/components/shared/auth-paywall/with-auth-gate";
import { ProfileProgressTrackerModal } from "@/components/shared/profile-progress-tracker-header/profile-progress-tracker-modal";
import { Skeleton } from "@/components/ui/skeleton";
import { useProfileCompletionState } from "@/hooks/use-profile-completion-state";
import type { User } from "@/lib/types/auth";

function ProfileProgressTrackerHeaderInner({ user }: { user: User }) {
  const { profileCompletionState, verificationStatus, queries } =
    useProfileCompletionState(user.id);

  return (
    <WhenAllReady
      queries={queries}
      loader={<ProfileProgressTrackerHeaderLoader />}
      ErrorWrapper={() => null}
    >
      <ProfileProgressTrackerModal
        state={profileCompletionState}
        verificationStatus={verificationStatus}
      />
    </WhenAllReady>
  );
}

function ProfileProgressTrackerHeaderLoader() {
  return (
    <div className="relative flex h-10 w-10 items-center justify-center">
      <Skeleton className="absolute inset-0 h-10 w-10 rounded-full bg-secondary/10" />
      <div className="relative z-10 flex h-8 w-8 items-center justify-center rounded-full border-2 border-secondary/30 bg-background">
        <Skeleton className="h-3 w-5 rounded-sm bg-secondary/30" />
      </div>
    </div>
  );
}

export const ProfileProgressTrackerHeader = withAuthGate(
  ProfileProgressTrackerHeaderInner,
  {
    customLoader: <></>,
    customPaywall: null,
  },
);
